import {trackAmplitudeEvent} from "@pg-mono/amplitude";

export type AmplitudeOfferContactButtonName = "offer_show_number" | "offer_call_investor";
type AmplitudeOfferDetailNavButtonName = "view_floor_plan" | "view_map";
type AmplitudeConstructionGalleryButtonName = "view_construction_photos" | "view_construction_stages";
type AmplitudeLocationButtonName = "check_location_map";
type AmplitudeVendorReportButtonName = "download_developer_report";
type AmplitudeCreditCalculatorButtonName = "ask_property_with_mortgage" | "view_bank_offers";
type AmplitudeComparisonWidgetButtonName = "view_comparison_offers" | "rp_go_to_comparison";
type AmplitudeFavouritesTopbarButtonName = "rp_favourites_show_all";
type AmplitudeOfferListViewButtonName = "offers_view_toggle";
type AmplitudeVendorWebsiteButtonName = "view_developer_website";
type AmplitudeGalleryContactButtonName = "rp_gallery_show_number";
type AmplitudeGalleryMapButtonName = "check_travel_time";
type AmplitudeHomeMatchOnOffModalButtonName = "rp_hm_on_off_modal_confirm";
type AmplitudePostPriceRevealButtonName = "rp_post_price_reveal_browsing_only";
export type AmplitudeUnlockChoiceButtonCategory =
    | "rp_post_price_reveal"
    | "rp_download_floor_plan"
    | "rp_price_history"
    | "rp_developer_report"
    | "rp_construction_photos"
    | "rp_faq";
export type AmplitudeUnlockChoiceButtonAction = "select" | "submit" | "close";
type AmplitudeUnlockChoiceButtonName = `${AmplitudeUnlockChoiceButtonCategory}_${AmplitudeUnlockChoiceButtonAction}`;
export type AmplitudeUnlockChoiceExitButtonName = "rp_preferences_close" | "rp_price_negotiate_submit" | "rp_price_negotiate_close";
type AmplitudeListingMapButtonName = "rp_listing_map_apartment_prev" | "rp_listing_map_apartment_next" | "ask_full_offer" | "see_property_details";
export type AmplitudePersonalizedHomepageButtonName =
    | "rp_homepage_recent_search"
    | "rp_homepage_recent_searches_show_more"
    | "rp_homepage_offers_for_you"
    | "rp_homepage_youtube_video"
    | "rp_homepage_youtube_channel"
    | "rp_homepage_consultant_call"
    | "rp_homepage_prices_show_more"
    | "rp_homepage_tinder_rate"
    | "rp_homepage_tinder_more_info"
    | "rp_homepage_tinder_see_all"
    | "rp_homepage_tinder_close";

type AmplitudeButtonName =
    | AmplitudeOfferContactButtonName
    | AmplitudeOfferDetailNavButtonName
    | AmplitudeConstructionGalleryButtonName
    | AmplitudeLocationButtonName
    | AmplitudeVendorReportButtonName
    | AmplitudeCreditCalculatorButtonName
    | AmplitudeComparisonWidgetButtonName
    | AmplitudeOfferListViewButtonName
    | AmplitudeVendorWebsiteButtonName
    | AmplitudeGalleryContactButtonName
    | AmplitudeGalleryMapButtonName
    | AmplitudeHomeMatchOnOffModalButtonName
    | AmplitudePostPriceRevealButtonName
    | AmplitudeListingMapButtonName
    | AmplitudeUnlockChoiceButtonName
    | AmplitudeUnlockChoiceExitButtonName
    | AmplitudePersonalizedHomepageButtonName
    | AmplitudeFavouritesTopbarButtonName;

export type AmplitudeButtonCategory =
    | "investment_page"
    | "property_page"
    | "homematch"
    | "rp_multilead"
    | "listing_page"
    | "homepage"
    | "rp_see_apartments"
    | "listing_map"
    | "rp_hm_on_off_modal"
    | AmplitudeUnlockChoiceButtonCategory;

export type AmplitudeHomeMatchAction = "hm_on" | "hm_off";

interface ITrackAmplitudeButtonClickParams {
    buttonName: AmplitudeButtonName;
    buttonCategory: AmplitudeButtonCategory;
    itemId: number | null;
    propertyId?: number | null;
    buttonLink?: string | null;
    value?: string | null;
    itemListId?: string | null;
    rpHmMatchAction?: AmplitudeHomeMatchAction;
    /** Button-specific properties defined per placement in the Amplitude knowledge base. */
    additionalEventProperties?: Record<string, string | number | null>;
}

export const trackAmplitudeButtonClick = (params: ITrackAmplitudeButtonClickParams) => {
    trackAmplitudeEvent("button_click", {
        button_name: params.buttonName,
        button_category: params.buttonCategory,
        item_id: params.itemId,
        property_id: params.propertyId ?? null,
        button_link: params.buttonLink ?? null,
        ...(params.value != null && {value: params.value}),
        ...(params.itemListId !== undefined && {item_list_id: params.itemListId}),
        ...(params.rpHmMatchAction != null && {rp_hm_match_action: params.rpHmMatchAction}),
        ...params.additionalEventProperties
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

export type AmplitudeOfferContactButtonName = "offer_show_number" | "offer_call_investor";
type AmplitudeOfferDetailNavButtonName = "view_floor_plan" | "view_map";
type AmplitudeConstructionGalleryButtonName = "view_construction_photos" | "view_construction_stages";
type AmplitudeLocationButtonName = "check_location_map";
type AmplitudeVendorReportButtonName = "download_developer_report";
type AmplitudeCreditCalculatorButtonName = "ask_property_with_mortgage" | "view_bank_offers";
type AmplitudeComparisonWidgetButtonName = "view_comparison_offers" | "rp_go_to_comparison";
type AmplitudeFavouritesTopbarButtonName = "rp_favourites_show_all";
type AmplitudeOfferListViewButtonName = "offers_view_toggle";
type AmplitudeVendorWebsiteButtonName = "view_developer_website";
type AmplitudeGalleryContactButtonName = "rp_gallery_show_number";
type AmplitudeGalleryMapButtonName = "check_travel_time";
type AmplitudeHomeMatchOnOffModalButtonName = "rp_hm_on_off_modal_confirm";
type AmplitudePostPriceRevealButtonName = "rp_post_price_reveal_browsing_only";
export type AmplitudeUnlockChoiceButtonCategory =
    | "rp_post_price_reveal"
    | "rp_download_floor_plan"
    | "rp_price_history"
    | "rp_developer_report"
    | "rp_construction_photos"
    | "rp_faq";
export type AmplitudeUnlockChoiceButtonAction = "select" | "submit" | "close";
type AmplitudeUnlockChoiceButtonName = `${AmplitudeUnlockChoiceButtonCategory}_${AmplitudeUnlockChoiceButtonAction}`;
export type AmplitudeUnlockChoiceExitButtonName = "rp_preferences_close" | "rp_price_negotiate_submit" | "rp_price_negotiate_close";
type AmplitudeListingMapButtonName = "rp_listing_map_apartment_prev" | "rp_listing_map_apartment_next" | "ask_full_offer" | "see_property_details";
export type AmplitudePersonalizedHomepageButtonName =
    | "rp_homepage_recent_search"
    | "rp_homepage_recent_searches_show_more"
    | "rp_homepage_offers_for_you"
    | "rp_homepage_youtube_video"
    | "rp_homepage_youtube_channel"
    | "rp_homepage_consultant_call"
    | "rp_homepage_prices_show_more"
    | "rp_homepage_tinder_rate"
    | "rp_homepage_tinder_more_info"
    | "rp_homepage_tinder_see_all"
    | "rp_homepage_tinder_close";

type AmplitudeButtonName =
    | AmplitudeOfferContactButtonName
    | AmplitudeOfferDetailNavButtonName
    | AmplitudeConstructionGalleryButtonName
    | AmplitudeLocationButtonName
    | AmplitudeVendorReportButtonName
    | AmplitudeCreditCalculatorButtonName
    | AmplitudeComparisonWidgetButtonName
    | AmplitudeOfferListViewButtonName
    | AmplitudeVendorWebsiteButtonName
    | AmplitudeGalleryContactButtonName
    | AmplitudeGalleryMapButtonName
    | AmplitudeHomeMatchOnOffModalButtonName
    | AmplitudePostPriceRevealButtonName
    | AmplitudeListingMapButtonName
    | AmplitudeUnlockChoiceButtonName
    | AmplitudeUnlockChoiceExitButtonName
    | AmplitudePersonalizedHomepageButtonName
    | AmplitudeFavouritesTopbarButtonName;

export type AmplitudeButtonCategory =
    | "investment_page"
    | "property_page"
    | "homematch"
    | "rp_multilead"
    | "listing_page"
    | "homepage"
    | "rp_see_apartments"
    | "listing_map"
    | "rp_hm_on_off_modal"
    | AmplitudeUnlockChoiceButtonCategory;

export type AmplitudeHomeMatchAction = "hm_on" | "hm_off";

interface ITrackAmplitudeButtonClickParams {
    buttonName: AmplitudeButtonName;
    buttonCategory: AmplitudeButtonCategory;
    itemId: number | null;
    propertyId?: number | null;
    buttonLink?: string | null;
    value?: string | null;
    itemListId?: string | null;
    rpHmMatchAction?: AmplitudeHomeMatchAction;
    /** Button-specific properties defined per placement in the Amplitude knowledge base. */
    additionalEventProperties?: Record<string, string | number | null>;
}

export const trackAmplitudeButtonClick = (params: ITrackAmplitudeButtonClickParams) => {
    trackAmplitudeEvent("button_click", {
        button_name: params.buttonName,
        button_category: params.buttonCategory,
        item_id: params.itemId,
        property_id: params.propertyId ?? null,
        button_link: params.buttonLink ?? null,
        ...(params.value != null && {value: params.value}),
        ...(params.itemListId !== undefined && {item_list_id: params.itemListId}),
        ...(params.rpHmMatchAction != null && {rp_hm_match_action: params.rpHmMatchAction}),
        ...params.additionalEventProperties
    });
};
